import { Paper, Select, Stack, Text } from '@mantine/core';
import { PaymentMethod } from '@/types';
import {
  usePaymentMethod,
  useInvoiceCurrency,
  useManualInvoiceActions,
} from '@/models/manual-invoice.store';
import { CURRENCY_OPTIONS } from '@/lib/constants';

const PAYMENT_METHOD_OPTIONS = [
  { value: PaymentMethod.BankTransfer, label: 'Bank Transfer' },
  { value: PaymentMethod.Cryptocurrency, label: 'Cryptocurrency' },
];

export default function InvoiceMetaSection() {
  const paymentMethod = usePaymentMethod();
  const invoiceCurrency = useInvoiceCurrency();
  const { setPaymentMethod, setCurrency } = useManualInvoiceActions();

  const isCrypto = paymentMethod === PaymentMethod.Cryptocurrency;

  return (
    <Paper p="md" withBorder>
      <Text size="xs" fw={600} c="dimmed" mb="xs" tt="uppercase">
        Invoice Details
      </Text>

      <Stack gap="xs">
        <Select
          size="xs"
          label="Payment Method"
          value={paymentMethod}
          onChange={(value) => {
            if (value) {
              setPaymentMethod(value as PaymentMethod);
            }
          }}
          data={PAYMENT_METHOD_OPTIONS}
        />

        <Select
          size="xs"
          label="Currency"
          value={invoiceCurrency}
          onChange={(value) => {
            if (value) {
              setCurrency(value as 'EUR' | 'USD');
            }
          }}
          data={CURRENCY_OPTIONS.filter((c) =>
            // For crypto, only show USD
            isCrypto ? c.value === 'USD' : true,
          )}
          disabled={isCrypto}
          description={
            isCrypto
              ? 'Cryptocurrency payments are processed in USD'
              : undefined
          }
        />
      </Stack>
    </Paper>
  );
}
